import Vue from "vue";
import VueRouter from "vue-router";
import Hours from "../views/Hours";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Root",
    // redirect: "/hours",
    component: Hours,
  },
  {
    path: "/hours",
    name: "Hours",
    component: Hours,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
